/**
 * Shared user-facing copy and defaults for transport / boundary errors.
 */

export const MSG_NETWORK =
  "Unable to connect to the server. Check your connection and try again.";
export const MSG_TIMEOUT =
  "The server took too long to respond. Please try again.";
export const MSG_SERVER =
  "Something went wrong on our side. Please try again.";
export const MSG_UNAVAILABLE =
  "The service is temporarily unavailable. Please try again.";
export const MSG_GENERIC = "Something went wrong. Please try again.";
export const MSG_GITHUB_BUSY =
  "GitHub is slow or unavailable right now. Please try again in a moment.";
export const MSG_GITHUB_TIMEOUT =
  "This GitHub request took too long. Please try again.";

/** Default Axios timeout for the shared backend client (ms). */
export const DEFAULT_API_TIMEOUT_MS = 180000;

/** Deduplicate burst failures for this many ms in the global boundary. */
export const API_ERROR_DEDUPE_MS = 4000;
